<template>
    <div class="mx-2 w-full">
        <div v-if="loadLines" class="flex flex-wrap gap-3">
            <div
                v-if="itemCurrent.line"
                class="flex items-center gap-3 flex-1 min-w-48 min-h-24 border border-theme-border rounded-xl px-4 py-3 bg-theme-card shadow-md"
            >
                <div class="flex-1 min-w-0">
                    <span
                        class="text-xs font-semibold uppercase tracking-widest text-theme-base"
                    >
                        Categoría
                    </span>
                    <a
                        :href="`/app/lines/detail/${itemCurrent.line.slug}`"
                        target="_blank"
                        rel="noopener"
                        class="block no-underline mt-0.5"
                    >
                        <p
                            class="text-sm font-semibold text-theme-primary truncate"
                        >
                            {{ itemCurrent.line.name }}
                        </p>
                        <span class="text-xs text-theme-muted font-mono">
                            {{ itemCurrent.line.slug }}
                        </span>
                    </a>
                </div>
                <div class="shrink-0">
                    <app-button
                        v-if="enabled"
                        :disabled="isLoading"
                        icon
                        @click="openLineSelector"
                    >
                        🖊️
                    </app-button>
                </div>
            </div>

            <div
                class="flex items-center gap-3 flex-1 min-w-48 min-h-24 border border-theme-border rounded-xl px-4 py-3 bg-theme-card shadow-md"
            >
                <div class="flex-1 min-w-0">
                    <span
                        class="text-xs font-semibold uppercase tracking-widest text-theme-base"
                    >
                        {{ itemCurrent.line ? "Subcategoría" : "Categoría" }}
                    </span>
                    <a
                        :href="`/app/lines/detail/${itemCurrent.slug}`"
                        target="_blank"
                        rel="noopener"
                        class="block no-underline mt-0.5"
                    >
                        <p
                            class="text-sm font-semibold text-theme-primary truncate"
                        >
                            {{ itemCurrent.name }}
                        </p>
                        <span class="text-xs text-theme-muted font-mono">
                            {{ itemCurrent.slug }}
                        </span>
                    </a>
                </div>
                <div class="shrink-0 flex gap-1">
                    <app-button
                        v-if="enabled"
                        :disabled="isLoading"
                        icon
                        @click="openSublineLineSelector"
                    >
                        🖊️
                    </app-button>
                    <app-button
                        v-if="enabled && itemCurrent.line"
                        :disabled="isLoading"
                        danger
                        icon
                        @click="deleteSubline"
                    >
                        🗑️
                    </app-button>
                </div>
            </div>

            <div
                v-if="enabled && !itemCurrent.line"
                class="flex items-center gap-3 flex-1 min-w-48 min-h-24 border-2 border-dashed border-theme-border rounded-xl px-4 py-3 shadow-md"
            >
                <div class="flex-1 min-w-0">
                    <span
                        class="text-xs font-semibold uppercase tracking-widest text-theme-muted"
                    >
                        Subcategoría
                    </span>
                </div>
                <button
                    type="button"
                    class="shrink-0 flex items-center justify-center w-10 h-10 rounded-full hover:bg-theme-hover transition-colors cursor-pointer"
                    @click="openSublineSelector"
                >
                    <span class="text-xl">➕</span>
                </button>
            </div>
        </div>

        <div v-if="enabled" class="flex mt-4">
            <div class="w-full flex justify-center">
                <app-button
                    :disabled="!itemCurrent.slug"
                    :loading="isLoading"
                    @click="updateSublineOfProduct"
                >
                    Actualizar categorías
                </app-button>
            </div>
        </div>

        <div>
            <app-dialog v-model="isSelectedLine" size="lg">
                <template #header>
                    <div
                        class="flex items-center justify-between gap-4 px-6 py-4 border-b border-theme-border w-full"
                    >
                        <div>
                            <h3 class="text-lg font-bold text-theme-base">
                                Selecciona una categoría
                            </h3>
                        </div>
                        <app-button
                            :disabled="!selectedLine"
                            @click="chooseLine"
                        >
                            ✔️ Seleccionar categoría
                        </app-button>
                    </div>
                </template>
                <div class="px-4 pt-3 pb-1">
                    <input
                        v-model="lineSearch"
                        type="text"
                        placeholder="Buscar categoría..."
                        class="w-full px-3 py-2 rounded-lg border border-theme-border text-sm text-theme-base outline-none focus:border-stack-primary transition-colors"
                    />
                </div>
                <div class="grid grid-col-1 sm:grid-cols-2 gap-2 px-4 py-3">
                    <button
                        v-for="(item, index) in filteredLines"
                        :key="index"
                        class="w-60 text-left px-4 py-3 rounded-lg border-2 bg-theme-card shadow-sm hover:shadow-md hover:bg-theme-hover transition-all cursor-pointer"
                        :class="
                            item.slug === selectedLine
                                ? 'border-theme-primary  ring-theme-primary ring-offset-1'
                                : 'border-theme-border'
                        "
                        @click="selectedLine = item.slug"
                    >
                        <div class="flex items-center justify-between gap-2">
                            <h3
                                class="font-medium"
                                :class="
                                    item.slug === selectedLine
                                        ? 'text-theme-primary'
                                        : 'text-theme-base'
                                "
                            >
                                {{ item.name }}
                            </h3>
                            <span
                                v-if="item.slug === selectedLine"
                                class="text-theme-primary text-base leading-none font-bold"
                                >✔</span
                            >
                        </div>
                        <p
                            class="text-sm mt-1"
                            :class="
                                item.slug === selectedLine
                                    ? 'text-theme-primary opacity-70'
                                    : 'text-theme-muted'
                            "
                        >
                            {{ item.slug }}
                        </p>
                    </button>
                </div>
            </app-dialog>
            <app-dialog v-model="isSelectSubline" size="lg">
                <template #header>
                    <div
                        class="flex items-center justify-between gap-4 px-6 py-4 border-b border-theme-border w-full"
                    >
                        <div>
                            <p
                                class="text-xs font-semibold uppercase tracking-widest text-theme-muted mb-1"
                            >
                                Subcategoría de
                                <strong>{{
                                    itemCurrent.line
                                        ? itemCurrent.line.name
                                        : itemCurrent.name
                                }}</strong>
                            </p>
                            <h3 class="text-lg font-bold text-theme-base">
                                Selecciona una subcategoría
                            </h3>
                        </div>
                        <div class="flex items-center gap-2">
                            <app-button border @click="isSelectSubline = false">
                                Usar categoría principal
                            </app-button>
                            <app-button
                                :disabled="!selectedSubline"
                                @click="chooseSubline"
                            >
                                ✔️ Seleccionar subcategoría
                            </app-button>
                        </div>
                    </div>
                </template>
                <div class="grid grid-col-1 sm:grid-cols-2 gap-2 px-4 py-3">
                    <button
                        v-for="(item, index) in sublinesByLine"
                        :key="index"
                        class="text-left w-60 px-4 py-3 rounded-lg border-2 bg-theme-card shadow-sm hover:shadow-md hover:bg-theme-hover transition-all cursor-pointer"
                        :class="
                            item.slug === selectedSubline
                                ? 'border-theme-primary  ring-theme-primary ring-offset-1'
                                : 'border-theme-border'
                        "
                        @click="selectedSubline = item.slug"
                    >
                        <div class="flex items-center justify-between gap-2">
                            <h3
                                class="font-medium"
                                :class="
                                    item.slug === selectedSubline
                                        ? 'text-theme-primary'
                                        : 'text-theme-base'
                                "
                            >
                                {{ item.name }}
                            </h3>
                            <span
                                v-if="item.slug === selectedSubline"
                                class="text-theme-primary text-base leading-none font-bold"
                                >✔</span
                            >
                        </div>
                        <p
                            class="text-sm mt-1"
                            :class="
                                item.slug === selectedSubline
                                    ? 'text-theme-primary opacity-70'
                                    : 'text-theme-muted'
                            "
                        >
                            {{ item.slug }}
                        </p>
                    </button>
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "LineSublineManage",
    components: { AppDialog },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            require: true,
            default: () => ({
                slug: "",
                name: "",
                summary: "",
                line: {
                    slug: "",
                    name: "",
                    summary: ""
                }
            })
        },
        productId: {
            default: () => 0,
            type: Number,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        isSelectedLine: false,
        isSelectSubline: false,
        selectedLine: null,
        selectedSubline: null,
        currentPageLine: 1,
        outdatedSublines: true,
        isLoading: false,
        loadedLines: false,
        sublinesByLine: [],
        lines: [],
        lineSearch: ""
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        filteredLines() {
            const q = this.lineSearch.trim().toLowerCase();
            if (!q) return this.lines;
            return this.lines.filter(
                (l) =>
                    l.name.toLowerCase().includes(q) ||
                    l.slug.toLowerCase().includes(q)
            );
        }
    },
    mounted() {},
    methods: {
        ...mapActions("commons", ["listAllLines"]),
        ...mapActions("lines", ["listSublinesByLine"]),
        ...mapActions("products", ["updateProductLine"]),
        async openSublineSelector() {
            this.isSelectSubline = true;
            await this.loadSublines(this.itemCurrent.slug);
        },
        async openLineSelector() {
            this.lineSearch = "";
            this.isSelectedLine = true;
            await this.loadLines();
        },
        async openSublineLineSelector() {
            if (this.itemCurrent.line) {
                this.isSelectSubline = true;
                await this.loadSublines(this.itemCurrent.line.slug);
            } else {
                this.isSelectedLine = true;
                await this.loadLines();
            }
        },
        async loadLines() {
            this.isLoading = true;
            try {
                this.lines = await this.listAllLines({
                    required: true
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.isSelectedLine = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async chooseLine() {
            const lineAux = this.lines.find(
                (i) => i.slug === this.selectedLine
            );
            if (lineAux) {
                this.isSelectedLine = false;
                this.$emit("change", {
                    slug: lineAux.slug,
                    name: lineAux.name,
                    summary: lineAux.summary,
                    line: null
                });
                this.outdatedSublines = true;
                await this.loadSublines(lineAux.slug);
            }
        },
        async loadSublines(lineSlug) {
            this.isLoading = true;
            try {
                this.sublinesByLine = await this.listSublinesByLine({
                    lineSlug,
                    required: this.outdatedSublines
                });
                this.outdatedSublines = false;
                if (this.sublinesByLine.length > 0) {
                    this.isSelectSubline = true;
                } else {
                    this.isSelectSubline = false;
                }
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.isSelectSubline = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateSublineOfProduct() {
            if (!this.itemCurrent.slug) {
                return this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Categoría invalida",
                    text: "Revisa por favor selecciona una categoría valida",
                    icon: "info"
                });
            }
            this.isLoading = true;
            try {
                await this.updateProductLine({
                    productId: this.productId,
                    lineSlug: this.itemCurrent.slug
                });

                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        chooseSubline() {
            const sublineAux = this.sublinesByLine.find(
                (i) => i.slug === this.selectedSubline
            );
            if (sublineAux) {
                this.isSelectSubline = false;
                if (this.itemCurrent.line) {
                    this.$emit("change", {
                        slug: sublineAux.slug,
                        name: sublineAux.name,
                        summary: sublineAux.summary,
                        line: this.itemCurrent.line
                    });
                } else {
                    this.$emit("change", {
                        slug: sublineAux.slug,
                        name: sublineAux.name,
                        summary: sublineAux.summary,
                        line: this.itemCurrent
                    });
                }
            }
        },
        deleteSubline() {
            this.$emit("change", {
                slug: this.itemCurrent.line.slug,
                name: this.itemCurrent.line.name,
                summary: this.itemCurrent.line.summary,
                line: null
            });
        }
    }
};
</script>

<style scoped>
.vs-card__group .vs-card__group-cards .vs-card-content {
    min-width: 15rem;
    margin-left: 20px;
}
</style>
